import React from 'react'
import DisplayFormatedNumber from '../../../../../components/DisplayFormatedNumber'
import { usePayoutPopupContext } from '../context'

const BonusPayoutSummary = () => {
  const { data } = usePayoutPopupContext()

  if (!data) {
    return null
  }

  const bonusRatePercent = data.bonusRate.totalBonusRate.toFixed(4)
  const discountRatePercent = (1 - data.discountRate).toFixed(3)

  const monthlyRevenue = <DisplayFormatedNumber value={data.monthlyRevenue} format="euroInt" />
  const bonusPayout = <DisplayFormatedNumber value={data.totalBonusPayout} format="euroInt" />
  const revenueThreshold = <DisplayFormatedNumber value={data.revenueThreshold} format="euroInt" />

  return (
    <>
      (({monthlyRevenue} - {revenueThreshold}) x {bonusRatePercent}) x {discountRatePercent} = {bonusPayout}
    </>
  )
}

export default BonusPayoutSummary
